/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manager_Question_FailedInputs */



/**
* | output |
* | --- |
* | "Saving didn't work. Please try again." |
*
* @param {Manager_Question_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manager_question_failed = /** @type {((inputs?: Manager_Question_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manager_Question_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Bewaren lukte niet. Probeer het opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'enregistrement a échoué. Veuillez réessayer.")
	return /** @type {LocalizedString} */ ("Saving didn't work. Please try again.")
});